export default __webpack_public_path__ + "static/media/post12.da66fcd7.jpg";